import {EnumUrlRefs, IWidget, IWidgetItem} from "../types/home";
import {linkToPostView, seoUrlWords} from "helpers/links-builders/post";

export const linkToListingView = (widget:IWidget,item: IWidgetItem): string => {
    const seoTitleLink = seoUrlWords(item.title);

    let refValue = "";
    if (widget?.codename === EnumUrlRefs.CONTINUE_BROWSING) {
        refValue = "CONTINUE-HOME";
    } else if (widget?.codename === EnumUrlRefs.RECOMMENDED) {
        refValue = "RECOMMENDED-HOME";
    } else if (widget?.codename === EnumUrlRefs.RECENTLY) {
        refValue = "RECENTLY-HOME";
    }

    if (item.category_reporting_name === "JobsVertical") {
        if (item.subcategory_reporting_name === "JobPoster") {
            return linkToPostView({
                id: item.id,
                view_type: item.subcategory_reporting_name || "JobPoster",
            });
        }
        if (item?.subcategory_reporting_name === "JobSeeker") {
            return linkToPostView({
                cv_id: item?.cv_id,
                view_type: item.subcategory_reporting_name || "JobSeeker",
            });
        }
    }

    return `${linkToPostView({ id: item.id })}/${seoTitleLink}?ref=${refValue}#ref=HOME`;
};

